mutation UnassociateMasterTemplateFromCampaign($masterTemplateId: ID!, $campaignId: ID!) {
    unassociateMasterTemplateFromCampaign(masterTemplateId: $masterTemplateId, campaignId: $campaignId)
}
